import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  email: string | null;
  mfaToken: string | null;
  setToken: (token: string, email?: string, refreshToken?: string) => void;
  setTokens: (token?: string, refreshToken?: string) => void;
  setMfaToken: (token: string | null) => void;
  clear: () => void;
}

// Token is stored in localStorage for the SPA — admin runs at admin.nutrayan.com.
// httpOnly-cookie auth (per RULES Art 12) is preferred and used by the backend
// for storefront; admin uses a Bearer token so the React SPA can attach it manually.
// The refresh token is persisted alongside so a reload can silently re-auth.
export const useAuth = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      refreshToken: null,
      email: null,
      mfaToken: null,
      setToken: (token, email, refreshToken) =>
        set({
          token,
          email: email ?? null,
          refreshToken: refreshToken ?? null,
          mfaToken: null,
        }),
      // Rotate tokens after a refresh without disturbing email; keep the existing
      // refresh token if the backend didn't return a new one.
      setTokens: (token, refreshToken) =>
        set({ token: token ?? null, refreshToken: refreshToken ?? get().refreshToken }),
      setMfaToken: (mfaToken) => set({ mfaToken }),
      clear: () => set({ token: null, refreshToken: null, email: null, mfaToken: null }),
    }),
    { name: "ntr_admin_auth", version: 2 },
  ),
);
